import React, { FC, useState, useMemo } from 'react';
import { makeStyles, Container } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  navSpace: {
    marginTop: 32,
  },
}));

const UseMemoSample: FC = () => {
  const classes = useStyles();
  const [wordIndex, setWordIndex] = useState(0);
  const [count, setCount] = useState(0);

  const words = ['i', 'am', 'learning', 'react'];
  const word = words[wordIndex];

  const getLetterCount = (wordString: any) => {
    let i = 0;
    while (i < 1000000) i += 1;

    return wordString.length;
  };

  const letterCount = useMemo(() => getLetterCount(word), [word]);

  const handleChangeIndex = () => {
    const next = wordIndex + 1 === words.length ? 0 : wordIndex + 1;
    setWordIndex(next);
  };

  return (
    <Container maxWidth="md" className={classes.navSpace}>
      <p>
        {word} has {letterCount} letters
      </p>
      <button type="button" onClick={handleChangeIndex}>
        Next word
      </button>
      <p>Counter: {count}</p>
      <button type="button" onClick={() => setCount(count + 1)}>
        +
      </button>
    </Container>
  );
};

export default UseMemoSample;
